// extracted by css-extract-rspack-plugin
export default {"donationStatusCard":"DonationStatusCard_donationStatusCard__cyXdr"};